import React, { useState, useEffect } from "react";
import { useLanguage } from "../contexts/LanguageContext";
import "../css/global.css";

const LoadingScreen: React.FC = () => {
  const { t } = useLanguage();
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setHidden(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`loading-screen${hidden ? " hidden" : ""}`}>
      <div className="loading-spinner" />
      <p className="loading-text">{t.loading}</p>
    </div>
  );
};

export default LoadingScreen;
